// Sound utility for playing notification sounds
class SoundManager {
  constructor() {
    this.sounds = {};
    // Initialize from localStorage, default to true
    this.enabled = localStorage.getItem('ventscape_sounds_enabled') !== 'false';
  }

  // Preload a sound
  preloadSound(name, url) {
    if (this.sounds[name]) return; // Already loaded
    
    const audio = new Audio(url);
    audio.preload = 'auto';
    
    // Handle loading errors gracefully
    audio.addEventListener('error', (e) => {
      console.warn(`Failed to load sound: ${name}`, e);
    });
    
    this.sounds[name] = audio;
  }

  // Play a sound
  async playSound(name, volume = 0.5) {
    // Check localStorage directly to avoid instance issues
    const currentSetting = localStorage.getItem('ventscape_sounds_enabled');
    const isEnabled = currentSetting !== 'false';
    
    if (!isEnabled) return;
    
    const audio = this.sounds[name];
    if (!audio) {
      console.warn(`Sound not found: ${name}`);
      return;
    }

    try {
      // Reset the audio to the beginning
      audio.currentTime = 0;
      audio.volume = Math.max(0, Math.min(1, volume)); // Clamp between 0 and 1
      
      // Play the sound
      await audio.play();
    } catch (error) {
      // Handle autoplay restrictions gracefully
      if (error.name === 'NotAllowedError') {
        console.log('Audio autoplay blocked by browser. User interaction required.');
      } else {
        console.warn(`Failed to play sound: ${name}`, error);
      }
    }
  }

  // Enable/disable all sounds
  setEnabled(enabled) {
    this.enabled = enabled;
    // Persist to localStorage
    localStorage.setItem('ventscape_sounds_enabled', enabled.toString());
  }

  // Check if sounds are enabled
  isEnabled() {
    return this.enabled;
  }

  // Set volume for a specific sound
  setVolume(name, volume) {
    const audio = this.sounds[name];
    if (audio) {
      audio.volume = Math.max(0, Math.min(1, volume));
    }
  }
}

// Create and export a singleton instance
export const soundManager = new SoundManager();

// Convenience functions
export const playNotificationSound = (volume = 0.5) => {
  return soundManager.playSound('dm_notification', volume);
};

export const preloadNotificationSounds = () => {
  // Preload the DM notification sound
  soundManager.preloadSound('dm_notification', '/notification-2.mp3');
};

export const toggleSounds = (enabled) => {
  soundManager.setEnabled(enabled);
};

export const areSoundsEnabled = () => {
  return soundManager.isEnabled();
};

// Debug function to test sound manually
export const testNotificationSound = () => {
  return playNotificationSound(0.8);
};